import {format, isDate, isValid, parse} from 'date-fns';

export const formatValidDateToString = (date: Date | string, dateFormat: string): string => {
    if (isDate(date) && isValid(date)) {
        return format(date, dateFormat);
    } else if (typeof date === 'string') {
        const parsedDate = parse(date, dateFormat, new Date());
        if (isValid(parsedDate)) {
            return format(parsedDate, dateFormat);
        }
    }
    return '';
};
